import { Cookie } from "@bankmonitor/bm-ui-kit";
import { AccountAnalysisApi, AccountSyncApi, Configuration } from "@bankmonitor/customer-portal-rest-client";
import { getCsrfToken } from "./csrf";

const MFA_TOKEN_COOKIE = "bm-mfa-token";
const MFA_TOKEN_HEADER = "bm_mfa_token";

export function buildRestClientHeaders(): Record<string, string> {
	const headers: Record<string, string> = {};

	const csrf = getCsrfToken();
	if (csrf) {
		headers[csrf.header] = csrf.token;
	}

	const mfaToken = Cookie.get(MFA_TOKEN_COOKIE);
	if (mfaToken) {
		headers[MFA_TOKEN_HEADER] = mfaToken;
	}

	return headers;
}

export const restClientConfiguration = new Configuration({
	basePath: "",
	credentials: "include",
	middleware: [
		{
			pre: async ({ url, init }) => ({
				url,
				init: { ...init, headers: { ...init.headers, ...buildRestClientHeaders() } },
			}),
		},
	],
});

export const accountAnalysisApi = new AccountAnalysisApi(restClientConfiguration);
export const accountSyncApi = new AccountSyncApi(restClientConfiguration);
